import { Icon } from '@assembly-js/design-system';
import { useMemo } from 'react';

import { MenuAction } from 'src/components/MenuAction';
import { Action } from 'src/constants';
import { ProductPriceTableRowModal } from 'src/routes/payments/services/types';

type EntityName = 'price' | 'service';

export interface ServicePriceActionsRendererProps {
  data: ProductPriceTableRowModal;
  handleClickRemove: (data: ProductPriceTableRowModal) => void;
  entityName: EntityName;
  isDeleteDisabled?: boolean;
  isPriceUsed?: boolean;
  mode?: string;
  onCurrentPriceAction?: Action;
}

export const ServicePriceActionRenderer = ({
  data,
  handleClickRemove,
  entityName,
  isDeleteDisabled,
  isPriceUsed,
  mode,
  onCurrentPriceAction,
}: ServicePriceActionsRendererProps) => {
  const toolTipLabel = useMemo(() => {
    if (isPriceUsed) {
      if (mode === 'Recurring') {
        return `Cannot delete this price because it is currently in use by the Subscription you are editing.`;
      }
      if (mode === 'All') {
        return `Cannot delete this price because it is currently in use by the payment link you are editing.`;
      }
      if (mode === 'OneTimeStore' || mode === 'subscriptionsStore') {
        return `Cannot delete this price because it is currently in use in your store.`;
      }
    }
    return `You can’t delete this ${entityName} because it has been used before (e.g. in invoice, subscription, store or payment link)`;
  }, [mode, entityName, isPriceUsed]);

  const actions: Action[] = [
    ...(onCurrentPriceAction ? [onCurrentPriceAction] : []),
    {
      name: `Delete`,
      onClick: () => handleClickRemove(data),
      icon: <Icon icon="Trash" className="h-3 w-3" />,
      isDelete: true,
      isDisabled: isDeleteDisabled || data.isUsed || isPriceUsed,
      tooltipLabel: toolTipLabel,
      ...(isDeleteDisabled && {
        tooltipLabel: `Each service must have at least one ${entityName}`,
      }),
    },
  ];

  return <MenuAction actions={actions} />;
};
